import React from 'react'
import { theme } from '../../theme/theme'
import { styled } from '@mui/material/styles'
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material'
import { Button, IconButton } from '@mui/material'
import { FormControl, FormControlLabel, Select, MenuItem, RadioGroup, Radio, TextField, Autocomplete, Popper } from '@mui/material'
import { Typography, Grid } from '@mui/material'
import { ReactComponent as CloseButtonIcon } from '../../assets/CloseXIcon.svg'
import { useGetCloudSystemSummariesQuery } from "../dashboard/apiDashboard"
import moment from 'moment'

const BoxSwapSelectionModal = (props) => {
    const [targetSerial, setTargetSerial] = React.useState('')
    const [archiveTarget, setArchiveTarget] = React.useState('yes')
    
    // Keep track of the time so we can re-render if the status is too old
    const [time, setTime] = React.useState(moment())
    React.useEffect(() => {
        const interval = setInterval(() => {
            setTime(moment())
        }, 1000);
        return () => {
            clearInterval(interval);
        };
    }, []);
    const isOnline = props.lastStatusUpdate && moment().subtract(2, 'minutes').isBefore(moment(props.lastStatusUpdate))

    React.useEffect(() => {
        // Reset to default when the modal opens
        if (props.open) {
            setTargetSerial('')
            setArchiveTarget('yes')
        }
    }, [props.open])

    const onChangeTargetSerial = (e, value) => {
        console.info('onChange', value)
        setTargetSerial(value)
    }

    const onChangeArchiveTarget = (e) => {
        setArchiveTarget(e.target.value)
    }

    const handleSave = () => {
        if (isSaveValid()) {
            props.onSave({
                targetSerial: targetSerial,
                archiveTarget: archiveTarget === 'yes',
            })
        }
    }

    const isSaveValid = () => {
        return targetSerial && isOnline
    }

    const isFBO = props.serialNumber.startsWith('SX-')

    const { 
        serialNumbers,
    } = useGetCloudSystemSummariesQuery({type: isFBO ? 'fbo' : 'cloudport'}, {
        selectFromResult: ({ data }) => ({ serialNumbers: (data?.map(summary => summary.serialNumber) ?? []).sort() })
    })

    return (
        <>
        <Dialog
            open={props.open}
            onClose={props.onClose}
            PaperProps={{
                className:'Software_tab',
                style: {
                  backgroundColor: "#0A1826",
                  width:'1000px',
                  minWidth:'1000px',                    
                }
            }}>
            <DialogTitle sx={{
                    color: theme.palette.primary.contrastText,
                    backgroundColor:'#2C5877',
                    fontWeight:700,
                    fontFamily:'Open Sans',
                    fontSize:'18px',                    
                    width:'100%',
                    letterSpacing: '0px'}}
                style={{
                  display: 'flex',
                  padding: '5px 15px',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}>
                Swap {isFBO ? 'Cloudport FBO' : 'Cloudport'} Devices
                <IconButton edge="end" onClick={props.onClose}><CloseButtonIcon /></IconButton>
            </DialogTitle>
            <DialogContent style={{padding: '20px 85px'}}>
                {!isOnline &&
                    <Typography sx={{
                        mx: 1, 
                        fontFamily:'Open Sans',
                        fontSize:'18px',
                        fontWeight:'700',                        
                        letterSpacing: '0px',
                        color: 'red',       
                        paddingTop:'5px',
                        paddingRight:'15px',
                        paddingBottom:'5px',       
                    }}>The new {isFBO ? 'Cloudport FBO' : 'Cloudport'} must be powered on to replace an existing device</Typography>
                }
                <Typography sx={{
                    mx: 1, 
                    font: 'normal normal bold 18px/24px Open Sans',
                    letterSpacing: '0px',
                    color: '#AEB1B4',
                    backgroundColor:'#222E3B',
                    border: '1px solid #4A525A',
                    borderRadius: '4px',
                    padding:'5px'}}>                                                
                        &nbsp;&nbsp;&#x2022;&nbsp;&nbsp;{props.serialNumber}
                </Typography>
                <br/>
                <FormControl xs={2} sx={{marginLeft: "auto", marginRight: "15px", width: '100%'}} size="small">
                <Grid container>
                    <Grid item>
                        <Typography sx={{
                            mx: 1, 
                            fontFamily:'Open Sans',
                            fontSize:'18px',
                            fontWeight:'700',                        
                            letterSpacing: '0px',
                            color: '#fff',       
                            paddingTop:'5px',
                            paddingRight:'15px'           
                        }}>Device to Replace:</Typography>
                    </Grid>
                    <Grid item>
                        <Autocomplete
                            id="targetSerialSelect"
                            options={serialNumbers}
                            onChange={onChangeTargetSerial}
                            sx={{width: '200px'}}
                            renderInput={(params) => <TextField {...params} sx={{
                                color: theme.palette.tertiary.contrastText,
                                fontFamily:'Open Sans',
                                fontSize:'16px',
                                fontWeight:'600',                            
                                letterSpacing: '0.32px',
                                "& .MuiAutocomplete-popupIndicator": {color: theme.palette.tertiary.contrastText},}}/>}
                            PopperComponent={styled(Popper)({
                                "& .MuiAutocomplete-paper": {backgroundColor: theme.palette.primary.main, color: theme.palette.primary.contrastText},
                                "& .MuiAutocomplete-paper .MuiAutocomplete-noOptions": {color: theme.palette.primary.contrastText}
                            })}
                        />
                    </Grid>
                </Grid>
                </FormControl>
                <FormControl xs={2} sx={{marginLeft: "auto", marginRight: "15px", width: '100%'}} size="small">
                <Grid container>
                    <Grid item>
                        <Typography noWrap sx={{
                            mx: 1, 
                            fontFamily:'Open Sans',
                            fontSize:'18px',
                            fontWeight:'700',                        
                            letterSpacing: '0px',
                            color: '#fff',       
                            paddingTop:'5px',
                            paddingRight:'15px'           
                        }}>Would you like to archive the {isFBO ? 'Cloudport FBO' : 'Cloudport'} device?</Typography>
                    </Grid>
                    <Grid item>
                    <RadioGroup value={archiveTarget} onChange={onChangeArchiveTarget} row sx={{ color: '#fff '}}>
                        <FormControlLabel value="yes" control={<Radio sx={{ color: '#fff', '&.Mui-checked': { color: '#fff' } }}/>} label="Yes" />
                        <FormControlLabel value="no" control={<Radio sx={{ color: '#fff', '&.Mui-checked': { color: '#fff' } }}/>} label="No" />
                    </RadioGroup>
                    </Grid>
                </Grid>
                </FormControl>
            </DialogContent>
            <DialogActions style={{padding: '0 90px 30px 90px'}}>
                <Button onClick={props.onClose} sx={{
                      backgroundColor: '#ADADAD', 
                      color: '#626262', 
                      height:'35px',
                      width:'95px',
                      fontWeight: '600',
                      textTransform:'none',
                      fontFamily: 'Open Sans',
                      fontSize: '15px',                             
                      letterSpacing: '0.53px'}}>Cancel</Button>
                <div style={{flex: '1 0 0'}}>{/*Spacer*/}</div>
                <Button disabled={!isSaveValid()} onClick={handleSave} sx={{
                    backgroundColor: theme.palette.tertiary.main, 
                    color: theme.palette.primary.contrastText,
                    height:'35px',
                    width:'95px',                    
                    fontWeight: '600',
                    fontFamily: 'Open Sans',
                    fontSize: '15px',                  
                    textTransform:'none',           
                    letterSpacing: '0.53px'}}>Save</Button>
            </DialogActions>
        </Dialog>
        </>
    )
}

export default BoxSwapSelectionModal
